import React from "react";
import { connect } from "react-redux";
import Loader from "Components/loader/Loader";
import PropTypes from "prop-types";
import * as resActions from "../../modules/resources";

import Tabs from "Components/tabs/Tabs";
import PersonalData from "../customers/settings/PersonalData";
import Security from "../customers/settings/Security";
import { displayFormattedDate } from "Utils/dateFormats";
import QboxmailApi from "../../qboxmailApi";
import { alertSuccess } from "Utils/alerts";
import withFormState from "Components/withFormState";
import { formatServerErrors } from "Utils/serverFormats";

import DetailInfo from "Components/detailInfo/DetailInfo";
import ButtonBack from "Components/buttonBack/ButtonBack";

import { t } from "i18next";
import cx from "classnames";
import s from "./showAdmins.scss";

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func
};

const formInitialState = {};

class AdminShowScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showInfo: this.props.isMediaMobile ? false : true
    };

    this.goBack = this.goBack.bind(this);
    this.toggleInfo = this.toggleInfo.bind(this);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    this.props.getAdmin(this.props.match.params.adminCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isAdminLoading && this.props.isAdminLoading) {
      const admin = nextProps.admin;
      this.props.setInitialValues({
        firstname: admin.firstname,
        lastname: admin.lastname,
        email_address: admin.email_address,
        language: admin.language,
        timezone: admin.timezone
      });
    }
  }

  validate(values) {
    const errors = {};
    const requiredFields = [/*'password', 'password_confirmation', */ "firstname", "lastname"];
    for (let i = 0; i < requiredFields.length; i++) {
      if (!values[requiredFields[i]]) errors[requiredFields[i]] = "is required";
    }

    // if (values.password.length < 8) errors.password = 'is too short. Must be at least 8 chars'

    // if (values.password_confirmation !== values.password_confirmation) {
    //   errors.password_confirmation = 'is not the same'
    // }
    return errors;
  }

  submitForm(e) {
    const {
      refreshAdmin,
      unsetFormLoading,
      setFormLoading,
      formData,
      setFormErrors,
      setInitialValues,
      match: {
        params: { adminCode }
      }
    } = this.props;
    e.preventDefault();
    setFormLoading();
    const errors = this.validate(formData);
    if (Object.keys(errors).length > 0) {
      unsetFormLoading();
      setFormErrors(errors);
    } else {
      const client = new QboxmailApi({ useCookie: true });
      client
        .editAdmin(adminCode, formData)
        .then(response => {
          refreshAdmin();
          alertSuccess(t("alert.admin.updated"));
          unsetFormLoading();
          setInitialValues(formData);
          this.resetAndGoBack();
        })
        .catch(response => {
          formatServerErrors(response).then(errors => {
            this.props.setFormErrors(errors);
            this.props.unsetFormLoading();
          });
        });
    }
  }

  goBack() {
    this.props.history.push("/admins");
  }

  toggleInfo() {
    this.setState({ showInfo: !this.state.showInfo });
  }

  render() {
    const { isAdminLoading, admin } = this.props;

    const { showInfo } = this.state;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    if (isAdminLoading) {
      return <Loader {...this.props} />;
    }

    return (
      <div className={s.showAdmin}>
        <div className={s.navigation}>
          <ButtonBack onClick={this.goBack} />

          <div className={s.viewSectionLabel}>{t("section.view.admin")}</div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">{`${admin.firstname} ${admin.lastname}`}</div>
            {isMediaMobile() && (
              <div className={cx(s.showInfo, "internalLink")} onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>

          {showInfo && (
            <div className={s.subtitle}>
              <div className="sectionDesc">{admin.email_address}</div>
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={admin.code} inLine />
              <DetailInfo
                label={t("detailInfo.label.created")}
                info={displayFormattedDate(admin.created_at)}
                inLine
              />
            </div>
          )}
        </div>

        <Tabs
          {...this.props}
          className={s.settings}
          tabs={{
            [t("tab.registry")]: (
              <PersonalData submitForm={this.submitForm.bind(this)} {...this.props} />
            ),
            [t("tab.security")]: (
              <Security adminVersion submitForm={this.submitForm.bind(this)} {...this.props} />
            )
          }}
        />
      </div>
    );
  }
}

AdminShowScreen.contextTypes = ContextTypes;

const mapStateToProps = state => ({
  admin: resActions.getData("admin.data.0", state),
  isAdminLoading: resActions.isResourceLoading("admin", state)
});

const mapDispatchToProps = dispatch => ({
  getAdmin: code => dispatch(resActions.callApi("getAdmin", "admin", code)),
  refreshAdmin: code => dispatch(resActions.callApi("refreshAdmin", "admin", code))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormState(AdminShowScreen, formInitialState));
